import { toast } from 'react-toastify';

import { ITokenSale, useRestoreTokenSaleMutation } from '@entities/trades/token-sell';
import { useModal } from '@shared/components/Modal';
import { isApiError } from '@shared/types/fetch-data';

interface IProps<T> {
  tokenSale: T;
  refetch: () => void;
}

export const RestoreTokenSale = <T extends ITokenSale>({ tokenSale, refetch }: IProps<T>) => {
  const [restoreTokenSale, { isLoading }] = useRestoreTokenSaleMutation();
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    const result = await restoreTokenSale(tokenSale.id);

    if ('data' in result) {
      closeModal();
      refetch();
    }

    if ('error' in result && isApiError(result.error)) {
      toast.error(result.error.data.message);
    }
  };

  return (
    <div className='modal-confirm'>
      <div className='modal-confirm__title'>Restore Token Sale</div>
      <div className='modal-confirm__message'>
        Are you sure you want to reject the dispute for token sale #{tokenSale.id}? The uploaded
        dispute file will be deleted, the order will return to pending and the trader will be asked
        to upload a new file.
      </div>
      <div className='modal-confirm__btns'>
        <button disabled={isLoading} className='btn-confirm' onClick={handleConfirm}>
          Restore
        </button>
        <button type='button' className='btn-cancel secondary-btn' onClick={closeModal}>
          Cancel
        </button>
      </div>
    </div>
  );
};
